// extracted by mini-css-extract-plugin
module.exports = {"participateContainer":"styles_participateContainer__oR2yK"};